import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/BtnInformationSmallDefault.webp'


const _withScopeId = n => (_pushScopeId("data-v-0b8a10e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, /*#__PURE__*/_toDisplayString("Event Schedule"), -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "notice-link" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon"
}, null, -1))
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "schedule" }
const _hoisted_8 = { class: "footer" }
const _hoisted_9 = { class: "daily-reset" }
const _hoisted_10 = { class: "daily-timer" }
const _hoisted_11 = { class: "settings" }
const _hoisted_12 = { class: "section" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "header" }, "Timers", -1))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "section" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "header" }, "Regions", -1))
const _hoisted_17 = { class: "categories" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "header" }, "Categories", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_countdown = _resolveComponent("countdown")!
  const _component_event_list = _resolveComponent("event-list")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      id: "nav",
      class: _normalizeClass({ hideNav: _ctx.$route.name && _ctx.$route.name === 'Notices' })
    }, [
      _withDirectives(_createElementVNode("div", _hoisted_1, _hoisted_3, 512), [
        [_vShow, _ctx.$route.name && _ctx.$route.name !== 'Notices']
      ])
    ], 2),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("a", {
        href: !_ctx.isGlobal 
        ? `https://api.heaven-burns-red.wfs.games/web/announcement?version=${_ctx.versionNum}&phoneType=4` 
        : `https://hbr-gs.yo-star.com/web/announcement?region=2&language=2&phoneType=4&version=${_ctx.versionNum}&assetVersion=${_ctx.versionNum}`,
        target: "_blank",
        rel: "noopener",
        class: "title"
      }, _toDisplayString("Open notice list"), 8, _hoisted_6)
    ], 512), [
      [_vShow, _ctx.$route.name && _ctx.$route.name !== 'Notices']
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(), _createBlock(_component_countdown, {
              key: _ctx.isGlobal ? _ctx.reset[1] : _ctx.reset[0],
              "is-reset": true,
              dates: {
                start: _ctx.isGlobal ? _ctx.reset[1] : _ctx.reset[0],
                end: '',
              }
            }, null, 8, ["dates"]))
          ])
        ])
      ]),
      _createVNode(_component_event_list, {
        data: _ctx.activeTimers,
        categories: false ? _ctx.selectedCategories : [],
        versions: _ctx.selectedVersions,
        sections: _ctx.selectedSections,
        "version-num": _ctx.versionNum,
        "no-padding": false,
        "is-global": _ctx.isGlobal
      }, null, 8, ["data", "categories", "versions", "sections", "version-num", "is-global"]),
      (_ctx.settingsModal)
        ? (_openBlock(), _createBlock(_component_modal, {
            key: 0,
            onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.settingsModal = false))
          }, {
            body: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allSections, (sec, k) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: k,
                      onClick: _withModifiers(($event: any) => (_ctx.selectSection(k + 1)), ["stop"]),
                      class: _normalizeClass(`settings-option ${
                  _ctx.selectedSections.find((s) => s === k + 1)
                    ? 'settings-option--active'
                    : 'settings-option--inactive'
                }`)
                    }, _toDisplayString(sec), 11, _hoisted_14))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.toggleVersion()), ["stop"])),
                    class: _normalizeClass(`wide settings-option ${
                  // selectedVersions.find((v) => v === j + 1)
                  _ctx.route.params.version &&
                  _ctx.availableVersions.includes(
                    _ctx.route.params.version.toString().toLowerCase()
                  )
                    ? 'settings-option--active'
                    : 'settings-option--inactive'
                }`)
                  }, _toDisplayString(_ctx.route.params.version &&
                  _ctx.availableVersions.includes(
                    _ctx.route.params.version.toString().toLowerCase()
                  )
                    ? _ctx.allVersions[
                        _ctx.availableVersions.findIndex(
                          (e) =>
                            e === _ctx.route.params.version.toString().toLowerCase()
                        )
                      ]
                    : "All"), 3)
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.selectCategory(``)), ["stop"])),
                  class: _normalizeClass(`category settings-option ${
                _ctx.totalCategories === _ctx.allCategories.length
                  ? 'settings-option--active'
                  : 'settings-option--inactive'
              }`)
                }, " All timers ", 2),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allCategories, (c, i) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: i,
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.selectCategory(``)), ["stop"])),
                    class: _normalizeClass(`category settings-option ${
                _ctx.selectedCategories.includes(``)
                  ? 'settings-option--active'
                  : 'settings-option--inactive'
              }`)
                  }, _toDisplayString(c), 3))
                }), 128))
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}